import { CreateCrilicReportReducerState, CrilicReportReducerDispatch, CrilicReportReduxTypes } from "./types";


const INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateCrilicReportReducer = (state: CreateCrilicReportReducerState = INIT_STATE, action: CrilicReportReducerDispatch) => {
    switch (action.type) {
        case CrilicReportReduxTypes.CRILIC_REPORT: {
            return {
                ...state,
                loading: true
            }

        }
        case CrilicReportReduxTypes.CRILIC_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case CrilicReportReduxTypes.CRILIC_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            }
        }
        case CrilicReportReduxTypes.RESET_CRILIC_REPORT: {
            return {
                data: {},
                loading: false,
                error: null
            }
        }
        default:
            return {...state};
    }
}

export {CreateCrilicReportReducer}